import { ChangeDetectionStrategy, Component, effect, signal } from '@angular/core';
import { Site } from 'src/app/bo/site';
import { ConfigurationTreeview } from 'src/app/bo/treeview/configuration-treeview';
import { ConfigurationTreeviewEnum } from 'src/app/bo/treeview/configuration-treeview.enum';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { Constants } from 'src/app/utils/constants';

@Component({
  selector: 'app-site-carte',
  templateUrl: './site-carte.component.html',
  styleUrls: ['./site-carte.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteCarteComponent {
  readonly Constants = Constants;
  site = signal<Site>(null);
  configurationTreeview = signal<ConfigurationTreeview>(new ConfigurationTreeview());
  configurationTreeviewNiveauDeux = signal(Constants.ConfigurationNiveauxAutres);
  configurationTreeviewNiveauTrois = signal(Constants.ConfigurationNiveauxAutres);


  constructor(private readonly utilService: UtilisateurService, private readonly http: HttpService, private readonly fonctions: FonctionsService) {
    effect(() => { this.onChangeSite(this.utilService.currentSite()); });
  }

  onChangeSite(site: Site): void {
    this.site.set(site);
    this.configurationTreeview.set(JSON.parse(site.configurationTreeview));
    this.onChangeConfiguration();
  }

  onSubmit(): void {
    const currentSite = this.site();
    currentSite.configurationTreeview = JSON.stringify(this.configurationTreeview());
    this.http.put<Site, Site>('Sites', currentSite).subscribe(resultat => {
      this.fonctions.launch_toast(true);
      this.utilService.setCurrentSite(resultat);
    }, _ => this.fonctions.launch_toast(false));
  }

  onChangeConfiguration(): void {
    const config = this.configurationTreeview();
    this.configurationTreeviewNiveauDeux.set(Constants.ConfigurationNiveauxAutres.filter(o => o.id !== config.niveauUn));
    this.configurationTreeviewNiveauTrois.set(Constants.ConfigurationNiveauxAutres.filter(o => (o.id !== config.niveauUn && o.id !== config.niveauDeux) || o.id === ConfigurationTreeviewEnum.Aucun));

    if (config.niveauUn === config.niveauDeux) {
      config.niveauDeux = ConfigurationTreeviewEnum.Aucun;
      config.niveauTrois = ConfigurationTreeviewEnum.Aucun;
    } else if (config.niveauDeux === config.niveauTrois) {
      config.niveauTrois = ConfigurationTreeviewEnum.Aucun;
    } else if (config.niveauUn === config.niveauTrois) {
      config.niveauTrois = ConfigurationTreeviewEnum.Aucun;
    } else if (config.niveauDeux === ConfigurationTreeviewEnum.Aucun) {
      config.niveauTrois = ConfigurationTreeviewEnum.Aucun;
    }
    this.configurationTreeview.set(config);
  }
}
